import { Entity } from '@backstage/catalog-model';
import { EntityFilter } from '@backstage/plugin-catalog-react';
import { INFRA_TYPE_ANNOTATION } from './catalogInfraTypes';

export class EntityInfraTypeAnnotationFilter implements EntityFilter {
  readonly value: string;

  constructor(
    private readonly mode: 'include' | 'exclude',
    private readonly infraTypes: string[],
  ) {
    this.value = `${mode}:${infraTypes.join(',')}`;
  }

  filterEntity(entity: Entity): boolean {
    const infraType = entity.metadata.annotations?.[INFRA_TYPE_ANNOTATION];
    // Repo-root Components (portal/infra TechDocs anchors) have no infra type.
    // Home must hide them; Docs still finds them via techdocs-ref.
    if (!infraType) {
      return false;
    }
    const matches = this.infraTypes.includes(infraType);
    return this.mode === 'include' ? matches : !matches;
  }

  toQueryValue(): string {
    return this.value;
  }
}
